import { gql } from '@apollo/client';
import 'cross-fetch/polyfill';
import { ROUTE_PATTERN_SITEMAP } from '../../constants';
import getHandler from './generic-file-handler';
export const fileQuery = gql`
  query {
    files: getFiles(
      where: { storeKey: "default_sitemap", filename: "sitemap-index.xml" }
      limit: 1
      sort: [{ property: "created", direction: "desc" }]
    ) {
      mimetype
      url
    }
  }
`;
export const pattern = new RegExp(ROUTE_PATTERN_SITEMAP);
export const handler = getHandler(fileQuery);
//# sourceMappingURL=sitemap.js.map